import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import { EditDeviceContext, IEditDeviceContext } from 'modules/Devices/EditDevice/editDeviceState/editDeviceContext';
import classNames from 'classnames';
import { useCompareFormData } from 'hooks/useCompareFormData';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		hardwareId,
		IDSelectedCustomer,
		IDSelectedRestaurant,
		bankSettings,
		initialFormData,
		tlsCertificateName,
		tlsCertificateFilePath,
		tlsCertificateFileId,
	} = useContext<IEditDeviceContext>(EditDeviceContext);
	const containerClasses = classNames(style.container, {
		[style.visible]: hardwareId || IDSelectedCustomer || IDSelectedRestaurant || tlsCertificateName,
	});

	const currentFormData = {
		hardwareId,
		IDSelectedCustomer,
		IDSelectedRestaurant,
		bankSettings,
		tlsCertificateName,
		tlsCertificateFilePath,
		tlsCertificateFileId,
	};

	const isEqualFormData = useCompareFormData(initialFormData, currentFormData);

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	return (
		<Form.Item>
			<div className={containerClasses} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={handleCancel}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" disabled={isEqualFormData} type="submit">
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
